import {
  Field,
  generateCompositeId,
  ID,
  InputAndObjectType,
  InputType,
  ObjectType,
} from '@warebee/shared/util-backend-only-types';
import { sortBy } from 'lodash';
import { Segment, Segment1D } from './geometry.model';

@ObjectType()
@InputType('AislePortalInput')
export class AislePortal {
  @Field(() => ID, { nullable: true })
  id?: string;

  @Field(() => ID)
  aisleId1: string;

  @Field(() => ID)
  aisleId2: string;

  @Field(() => Segment)
  coords: Segment;
}

export function generateAislePortalId(aisleId1: string, aisleId2: string) {
  return generateCompositeId(sortBy([aisleId1, aisleId2]));
}

export function getAislePortalId(p: AislePortal) {
  return p.id || generateAislePortalId(p.aisleId1, p.aisleId2);
}

@ObjectType()
@InputType('BayPortalInput')
export class BayPortal {
  @Field(() => ID)
  aisleId: string;
  @Field(() => ID)
  bayId: string;
  @Field(() => Segment)
  coords: Segment;
  @Field(() => Segment1D)
  bayProjection: Segment1D;
}

export interface ConnectivityGraph {
  aislePortals: AislePortal[];
  bayPortals: BayPortal[];
}

export function resolveAislePortalIds<G extends ConnectivityGraph>(cg: G): G {
  return {
    ...cg,
    aislePortals: cg.aislePortals.map(ap => ({
      ...ap,
      id: ap.id || getAislePortalId(ap),
    })),
  };
}

@InputAndObjectType()
export class PlaneConnectivityGraph implements ConnectivityGraph {
  @Field(() => ID)
  id: string;

  @Field(() => [AislePortal])
  aislePortals: AislePortal[];

  @Field(() => [BayPortal])
  bayPortals: BayPortal[];
}

@InputAndObjectType()
export class LayoutConnectivityGraph {
  @Field(() => [PlaneConnectivityGraph])
  planes: PlaneConnectivityGraph[];
}
